export default __webpack_public_path__ + "static/media/arrow-up.0e5da604.svg";